/**
*@Author zhoutong
*@Date 2021-11-11
*@Project WebStorm-admin-feature-cooperation-manage
*/
<template>
  <div class="ToolBarMonth-container">
    <div class="tabs-content">
      <div style="display: flex">
        <div class="tabs-item" @click="tabsClick(i)"
             :key="index"
             v-for="(i, index) in tabsData">
          <div ref="tabsItem">
            <el-badge :value="i.count">
              <span :class="{ active: i.active === active }">{{ i.tabName }}</span>
            </el-badge>
          </div>
        </div>
        <p class="bottom-line" :style="{
        transform:`translateX(${translateX}px)`,
        width:`${translateWidth}px`
      }"></p>
      </div>
      <div class="toolbar-warp">
        <span
            v-if="active === 1"
            @click="setAllRead"
            style="color: #0d9869;cursor: pointer;
            margin-right: 20px;
            font-size: 14px">全部已读</span>
        <el-select v-model="readValue"
                   v-show="active === 1"
                   style="width: 150px;margin-right: 15px"
                   size="mini"
                   placeholder="请选择">
          <el-option
              v-for="item in optionsRead"
              :key="item.value"
              :label="item.name"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="timeValue"
                   style="width: 150px;margin-right: 15px"
                   size="mini"
                   placeholder="请选择">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.name"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="searchValue"
                  size="mini"
                  style="width: 200px;margin-right: 15px"
                  placeholder="请输入内容"></el-input>
        <img :src="Sousuo"  @click="event(0)" style="margin-right: 15px" alt="">
        <img :src="Shuaxin" @click="event(1)" alt="">
      </div>
    </div>
    <div class="tabs-main">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Sousuo from '@/common/images/sousuo.svg'
import Shuaxin from '@/common/images/shuaxin.svg'
export default {

  name: "ToolBarMonth",

  props: {
    tabsData: {
      type: Array,
      default: () => [],
    },
    flowDetail:{
      type: Boolean,
      default: () => false,
    },
    active: {
      type: Number,
      default: () => 0,
    },
  },

  components: {},

  data() {
    return {
      readValue:'TODO',
      options:[
        {
          name:'所有时间',
          value:''
        },
        {
          name:'24小时',
          value:'H24'
        },
        {
          name:'3天',
          value:'D3'
        },
        {
          name:'7天',
          value:'D7'
        }
      ],
      optionsRead:[
        {
          name:'未读',
          value:'TODO'
        },
        {
          name:'已读',
          value:'DONE'
        }
      ],
      searchValue:'',
      timeValue:'',
      Sousuo,
      Shuaxin,
      translateX:0,
      translateWidth:0
    }
  },

  watch: {
    active: {
      handler:function (v){
        this.$nextTick(()=>{
          this.translateX = this.getWindowRelativeOffset(this.$refs.tabsItem[v].offsetParent,this.$refs.tabsItem[v]).left
          this.translateWidth = this.$refs.tabsItem[v].offsetWidth
          if(v === 1){
            this.readValue = 'TODO'
          }
        })
      },
      immediate: true
    }
  },

  mounted() {

  },

  methods: {
    clearData(){
      this.timeValue = ''
      this.searchValue = ''
      this.readValue = 'TODO'
    },
    setAllRead(){
      this.$emit('setAllRead')
    },
    event(v, refresh = true){
      if(v === 1){
        this.clearData()
      }
      this.$emit('setEvent', {
        type:v,
        time:v === 0 ? this.timeValue : '',
        value:v === 0 ? this.searchValue : '',
        read:v === 0 ? this.readValue : 0,
        refresh
      })
    },
    tabsClick(index) {
      if (this.active === index.active) return;
      this.$emit('tabsClickEvent', index.active);
    },
    getWindowRelativeOffset(parentWindow, elem) {
      const offset = {
        left : 0
      };
      const extend = {
        parentOffsetLeft : 0,
        childrenOffsetLeft : 0
      }
      extend.childrenOffsetLeft = elem.getBoundingClientRect().left;
      extend.parentOffsetLeft = parentWindow.getBoundingClientRect().left;
      offset.left =  extend.childrenOffsetLeft - extend.parentOffsetLeft;
      return offset;
    }
  },
}
</script>

<style scoped lang="scss">
.ToolBarMonth-container {
  display: flex;
  flex-direction: column;
  .toolbar-warp{
    display: flex;
    align-items: center;
    img {
      cursor: pointer;
    }
  }
  .tabs-content {
    height: 38px;
    width: 100%;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    border-bottom: 1px solid #eee;
    position: relative;
    .tabs-item {
      color: #666;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      padding: 0 20px 0 20px;
    }
    .tabs-item:first-child{
      padding: 0 20px 0 0
    }
    .active {
      color: #47c285;
    }
    .bottom-line {
      height: 2px;
      position: absolute;
      background: #47c285;
      width: 40px;
      left: 0;
      bottom: -2px;
      transition: 0.2s;
    }
  }
  .tabs-main{
    margin: 18px 0  18px 0;
  }
}
</style>